import React, { Component } from 'react';
import { AuthContext } from "../../../components/Auth/AuthDataProvider.jsx";
import BreadCrumb from "../../../components/Navs/Breadcrumb"
import { 
  Box,
  Grid,
  CircularProgress,
  Menu,
  MenuItem,
} from '@material-ui/core';
import CustomDateRangePicker from '../../../components/CustomFields/CustomDateRangePicker.jsx';
import apiUtil from "../../../api/apiUtil.jsx";
import api from "../../../api/api.jsx";
import ldsApi from "../../../api/ldsApi.jsx";
import { Container, Row, Col, Button, Card, Table } from 'react-bootstrap';
import moment from 'moment';
import QRCode  from "qrcode.react";
import EVFYLogo from '../../../assets/img/evfy-logo2.png';
import location from '../../../assets/img/Vector.png';
import building from '../../../assets/img/building.png';
import box from '../../../assets/img/box.png';
import comment from '../../../assets/img/comment.png';
import person from '../../../assets/img/person.png';
import time from '../../../assets/img/access_time.png';
import phone from '../../../assets/img/local_phone.png';
import bottomTxt from '../../../assets/img/bottom-txt.png';
import EVFYLogoForLabel from '../../../assets/img/EVFY_Logo.png';
import ReactDOM from 'react-dom';
import Barcode from 'react-barcode';
import evfyLogo from '../../../assets/img/evfy-logo2.png';
import discount0 from '../../../assets/img/discount/discount-1.png';
import discount1 from '../../../assets/img/discount/discount-2.png';
import discount2 from '../../../assets/img/discount/discount-3.png';
import discount3 from '../../../assets/img/discount/discount-4.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowUpFromBracket, faCircle, faDownload, faFileLines, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import jsPDF from "jspdf";
import 'jspdf-autotable';
import CustomButton from '../../../components/CustomFields/CustomButton.jsx';
import CustomDialog from '../../../components/Dialog/CustomDialog.jsx';
import JobImportDialog from '../../Jobs/Partial/JobImportDialog.jsx';
import {Verdana} from '../../../components/Fonts/Verdana'
import { InterLight } from '../../../components/Fonts/InterLight.jsx';
import { InterBold } from '../../../components/Fonts/InterBold.jsx';
import NaturalFood from '../../../assets/img/analytic_icons/NaturalFood.svg'
import Checkmark from '../../../assets/img/analytic_icons/Checkmark.svg'
import CustomPieChart from '../../../components/Charts/PieCharts';
import wmsApi from "../../../api/wmsApi.jsx";
import NormalPieChart from '../../../components/Charts/NormalPieChart';
import OldTable from '../../../components/Table/OldTable.jsx';
import BoxImportant from '../../../assets/img/analytic_icons/BoxImportant.svg'
import CustomUploadButton from '../../../components/CustomFields/CustomUploadButton.jsx';
import CustomDeliveryPerDayChart from '../../../components/Charts/DeliveryPerDay.jsx';
/**
 * http://lds-api.taskk.me/admin/api/orders/job/stats?start_date=2019-05-01&end_date=2020-11-23
 * http://lds-api.taskk.me/admin/api/dashboard/recent_activity/?start_date=2019-05-01&end_date=2020-11-23
 * http://lds-api.taskk.me/admin/api/dashboard/delivery_perday/?start_date=2019-05-01&end_date=2020-11-23
 */

 const { 
  REACT_APP_JOB_UPDATE_SOCKET_URL,
  REACT_APP_LDS_API_URL,
} = process.env;

class CustomerDashboard extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props);

    let rangeDate = {
      startDate:moment().subtract(6, 'days'),
      endDate: moment(),
    };
    let rangeDateItem = localStorage.getItem(this.pageName + '_rangeDate');
    if(rangeDateItem && rangeDateItem !== ''){
      try {
        rangeDate = JSON.parse(rangeDateItem);
      }catch(e){}
    }
    let userInfo = JSON.parse(localStorage.getItem("user"));
    let userName = `${userInfo.owner_info.first_name ? userInfo.owner_info.first_name : '' } ${userInfo.owner_info.last_name ? userInfo.owner_info.last_name : '' }`;

    this.state = {
      jobTab: 0,
      jobTabTable: 0,

      dateRangePickerIsOpen: false,
      company_logo: '',
      orders_logo: [],
      rangeDate: rangeDate,
      startDate: rangeDate.startDate,
      endDate: rangeDate.endDate,
      isLoadingOrder: false,
      isLoadingStatus: false,
      status: [],
      tableStatus: [],
      statusSelected: null,
      order_status: null,
      isLoading: false,
      isLoadingDelivery: false,
      isStatLoading: false,
      grouping: true,
      limit: apiUtil.getDefaultPageSize(),
      data: [],
      total: 0,
      page: 1,
      user_name: userName,
      total_delivery: 0,
      openDialog: false,
      openDialogItem: null,
      user: JSON.parse(localStorage.getItem('user')),
      openPreviewDialog: false,
      openPreviewDialogItem: null,

      openImportDialog : false,
      openImportDialogItem: null,
      data_form : [],

      stats : [],
      recent_activity : [],
      delivery_perday : [],
      discount_list: [],
      status_total: 0,
      current_discount: '',
      win_discount: '',
      order_data: [],
      order_reasons: [],
      reason_total: 0,
      isLoadingReason: false,
      factors: [],
      isLoadingFactor: false,
      overview_data: [],
      isLoadingClient: false,
      driver_entity: [],
      driverEntityLoading: false,
      isLoadingRecent: false,
      co2EvLoading: false,
      co2_ev_saving: 0,
      co2_emission: 0,
      grennerLoading: false,
      greener_count: 0
    }
  }
  componentDidMount() {
    window.history.replaceState({}, document.title, '/customer-dashboard');
    var path = window.localStorage.getItem('access_token');
    if(path == null){
      if( ! (window.location.pathname == "/Sign-in"  || window.location.pathname == "/Sign-up"  || window.location.pathname == "/privacy_policy" ||  window.location.pathname == "/terms_and_conditions"  ||  window.location.pathname == ("/sign-up-success") || window.location.pathname.includes("/login")) ) {
        window.location.href ="Sign-in";
      }
    }

    this.callInitApis();
  }
  
  getGrennerChoice = () => {
    const { accessToken } = this.context;
    
    this.setState({
      grennerLoading: true,
    }, () => {    
      let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());
  
      let param = {
        start_date: startDate,
        end_date: endDate,
      };
      
      ldsApi.read('/analytic/greener_choice/', param, accessToken)
      .then((result) => {
        // recent_activity
        apiUtil.parseResult(result, (data) => {
          this.setState({
            greener_count: data.result,
            grennerLoading: false,
          });
        }, (error, type) => {
          this.setState({
            driver_entity: [],
            grennerLoading: false,
          });
        });
  
      });
      
    });    
  }
  

  callReadApi = (search = '' ) => {

    let accessToken = localStorage.getItem("access_token")
    this.setState({
      isLoading:true
    })
    let param = {
      sort: "latest",
      page: 1,
      take: 3,
      customer: true,
      light_data: true
    };

      ldsApi.read("client_driver_billings", param, accessToken)
      .then( (results) => {
          apiUtil.parseResult(results, (data) => {
          let result = data.result.length > 0 ? data.result : []
          this.setState({
            data: result,
            isLoading: false
          })
          }, (error, type) => {
            this.setState({
              isLoading: false
            })

          });
      });
  }

  getDriverEntity = () => {
    const { accessToken } = this.context;
    
    this.setState({
      driverEntityLoading: true
    }, () => {
      let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());

      let param = {
        start_date: startDate,
        end_date: endDate,
      };

        ldsApi.read('/analytic/driver_entity/', param, accessToken)
        .then((result) => {
          // recent_activity
          apiUtil.parseResult(result, (data) => {
            this.setState({
              driver_entity: data.result,
              driverEntityLoading: false,
            });
          }, (error, type) => {
            this.setState({
              driver_entity: [],
              driverEntityLoading: false,
            });
          });

      });
    });     
  }


  callOrderReadApi = () => {
    const { accessToken } = this.context;
    
    this.setState({
      isLoadingOrder: true
    }, () => {
      let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());
      let param = {
        start_date: startDate,
        end_date: endDate,
        order_status: this.state.order_status,
        sort: "latest",
        client_light_data: true,
      };
      
      // if(order)
      ldsApi.read('orders', param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              order_data: (data.result && data.result.length > 0) ? data.result : [],
              company_logo : data.company_logo_base_64? data.company_logo_base_64 : '',
              orders_logo : data.orders_image_base64.length > 0? data.orders_image_base64 : [],
              total: data.total,
              isLoadingOrder: false,

            });

            // this.loadStatusApi();
          }, (error, type) => {
            this.setState({
              data: [],
              total: 0,
              isLoadingOrder: false,
            });
          });
      });
    });
  }

  /* IMPORT API */
  callImportApi = (row, callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      ldsApi.create('create/orders/multiple', row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading: false,
            }, () => {
              apiUtil.toast(
                'Jobs Successfully Imported',
                "check_circle"
              )
              if(callback){
                callback(data);
              }
            });
          }, (error, type) => {
            apiUtil.toast(
              error,
              "check_circle"
            )
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(null);
              }
            });
          });
      });
    });
  }
  /* END IMPORT API */
  
  importDialog = () => {
    return <CustomDialog 
      open={this.state.openImportDialog}
      title={'Import Order'}
      maxWidth={'md'}
      padding={'0'}
      hideButtons={true}
      onClose={() => {
        this.setState({
          openImportDialog: false,
          openImportDialogItem: null,
          excle_file: '',
          data_form: []
        });
      }}
    >
      <JobImportDialog
      collection_data={false}
        file={this.state.openImportDialogItem}
        isLoading={this.state.openImportDialogIsLoading}
        onClose={() => {
          this.setState({
            openImportDialog: false,
            openImportDialogItem: null,
            openImportDialogIsLoading: false,
            data_form: [],
            excle_file: '',
          });
        }}
        onImport={(form) => {
          this.setState({
            data_form: form,
            openImportDialog: false,
            openImportDialogItem: null,
            openImportDialogIsLoading: false
          }, ()=> {
          setTimeout(() =>
          this.callImportApi(form, (data) => {
            let all_jobs = (form && form.length > 0) ? form.length : 0;
            let failed_orders = (data && data.failed_orders && data.failed_orders.length > 0) ? data.failed_orders.length : 0;
            let invalid_company_code_orders = (data && data.invalid_company_code_orders && data.invalid_company_code_orders.length > 0) ? data.invalid_company_code_orders.length : 0;
            let saved_orders = (data && data.saved_orders && data.saved_orders.length > 0) ? data.saved_orders.length : 0;
            
            if(failed_orders > 0){
              apiUtil.toast(failed_orders + ' of ' + all_jobs + ' jobs have not successfully imported', 'check_circle', 'error');
            }
            if(invalid_company_code_orders > 0){
              apiUtil.toast(invalid_company_code_orders + ' of ' + all_jobs + ' company code does not match, jobs have not successfully imported', 'check_circle', 'error');
            }

            if(saved_orders > 0){
              apiUtil.toast(saved_orders + ' of ' + all_jobs + ' Jobs Successfully Imported', 'check_circle', 'success');
            }
          }, ()=> {
            this.callInitApis();
          }) , 3000);
            
        })}}
      />
    </CustomDialog>
  }

  /* EXPORT API */
  callExportInvoicePDF = () => {

    let pdf = new jsPDF("p", "mm", "a4");

    let index = 0;
    // let data = row?[row]:this.state.data;  
    
      if(index!= 0 ){  pdf.addPage(); }
        pdf.addImage(evfyLogo, 'PNG',10,8, 60, 24);
        pdf.setFont("verdana","bold","800");
        pdf.setFontSize(12);
        pdf.text(110,12, 'Evfy Pte Ltd');  

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(110,17, "84 Genting Lane");
        pdf.text(110,22, "#02-02");
        pdf.text(110,27, "Singapore 349584");
        pdf.text(110,32, "ACRA No.: 202121256D");
        pdf.text(110,37, "Email: hello@evfy.sg");
        pdf.text(110,42, "Phone: +65 8932 3141");

        pdf.setFontSize(10);
        pdf.setFont("verdana","bold","800");
        pdf.text(10,48, 'Company Name'); 
        pdf.text(10,53, 'Email Address'); 

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        let primary_address_1 = "Primary Address Line 1		";
        let primary_address_2 = "Primary Address Line 2		";
        let primary_address_3 = "Primary Address Line 3		";
        pdf.text(10,58, primary_address_1); 
        pdf.text(10,63, primary_address_2); 
        pdf.text(10,68, primary_address_3); 

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(110,37, "Email: hello@evfy.sg");
        pdf.text(110,42, "Phone: +65 8932 3141");

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(140,53, "From");
        pdf.text(170,53, "To");

        pdf.setFont("verdana","bold","800");
        pdf.text(110,58, "Period:");
        pdf.text(110,63, "Invoice Number:");
        pdf.text(150,63, "	EVFY_year/mth/running no.	");
        pdf.text(110,68, "Date of Invoice:");

        pdf.autoTable({ 
          head: [ [{content: 'Delivery Invoice', colSpan:8,
                  styles: { halign: "center"}}],
                ['S/N', 'Date', 'Order Number', 'Job Type', 'Qty', 
                'Base Charge (SGD)', 'Surcharges (SGD)', 'Amount (SGD)']],
          body: [
            ['1', '', '', '', '', '' ,'', '$0.0'],
            ['2', '', '', '', '', '' ,'', '$0.0'],
            ['3', '', '', '', '', '' ,'', '$0.0'],
            ['4', '', '', '', '', '' ,'', '$0.0'],
            ['5', '', '', '', '', '' ,'', '$0.0'],
            [{content: 'This is an auto-generated invoice by Evfy Pte Ltd. For discrepencies, please contact us at 89323141', colSpan:6, 
            styles: { halign: "left", lineWidth: 0 }},
            {content: 'Discount (%)', colSpan:1, 
              styles: { halign: "right", lineWidth: 0 }
            }, '0 %'],
            [{content: 'Subtotal', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
            [{content: 'GST', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
            [{content: 'AMOUNT DUE TO US', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
          ],
          margin: { horizontal: 10, top: 75 },
          styles: { overflow: "linebreak" },
          bodyStyles: { valign: "top", halign: "center" },
          headerStyles: { fillColor: '#FFFFFF', textColor: 0, lineWidth: 0.5 },
          columnStyles: { email: { columnWidth: "wrap" } },
          theme: "grid",
            });

            pdf.autoTable({ 
            body: [
              [{content: 'The terms of payment shall be no later than 30 days from the date of invoice. For Cheque payment, please issue in favour of Evfy Pte Ltd For bank transfer payment: UOB 375-311-528-3', rowSpan:4,
              styles: { halign: "left", lineWidth: 0}}, {content: 'Official Use', colSpan:2,
              styles: { halign: "left"}}],
              [ {content: 'Status :', styles: { halign: "left"}}, 
                {content: 'Unpaid', rowSpan:3, styles: { halign: "left", fillColor: '#c3c3c3',}}],
                [{content: 'Mode:', styles: { halign: "left"}}], 
                [{content: 'Reference:', styles: { halign: "left"}}] 
            ],
            margin: { horizontal: 10, top: 75 },
            styles: { overflow: "linebreak" },
            bodyStyles: { valign: "top", halign: "center" },
            headerStyles: { fillColor: '#FFFFFF', textColor: 0, lineWidth: 0.5 },
            columnStyles: { 
              email: { columnWidth: "wrap" }, 
              0: {
                columnWidth: 120 },
              1: {
                columnWidth: 'auto' } },
            theme: "grid",
              });


        pdf.save(`Invoice.pdf`);
  }
  /* END EXPORT API */

    /* PDF GENERATE */ 

    generatePDF = () => {
      const { accessToken } = this.context;
      let selectedRow = this.rowData;
      let ids = '';
      if(selectedRow != null && selectedRow != '') {
        selectedRow.map((item, i) => { ids += item.id +','; });
      } 
      ids = ids.slice(0, -1);
      
      if(ids != "") {
        window.open(REACT_APP_LDS_API_URL + 'multiple_generate_label.pdf?ids=' + ids + '&accessToken='+accessToken,'_blank');    
      } else {
        apiUtil.toast("Please select data for generation", "check_circle")
      }
  
    } 
  
    generatePOD = ( ) => {
      const { accessToken } = this.context;
      let ids = '';
      this.state.order_data.map((item, i) => { ids += item.id +','; });
      ids = ids.slice(0, -1);
      if(ids != "") {
        window.open(REACT_APP_LDS_API_URL + '/multiple_generate_pod.pdf?ids=' + ids + '&accessToken='+accessToken,'_blank');
      } else {
        apiUtil.toast("Please select data for generation", "check_circle")
        // window.open(REACT_APP_LDS_API_URL + '/multiple_generate_pod.pdf?start_date=' + moment(this.state.startDate).format("YYYY-MM-DD") + "&end_date=" + moment(this.state.endDate).format("YYYY-MM-DD") + '&is_customer=true' + '&application_company_id=' + this.state.user.owner_info.application_company_id,'_blank');
      }
      // window.open(REACT_APP_LDS_API_URL + '/multiple_generate_pod.pdf?ids=' + ids + '&is_customer=true' + '&application_company_id=' + this.state.user.owner_info.application_company_id,'_blank');
    }

  loadStatusApi = (callback = null) => {
    this.callStatusApi((data, total) => {
      if(data && data.length > 0){
        let status = [];
        let AckTep = {}
        let AssignToVendorTemp = {}
        let complete_total = 0;
        let fail_total = 0;
        data.map((item, i) => {

          if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "completed") {
            complete_total = item.delivery_count;
          }
          if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "failed") {
            fail_total = item.delivery_count;  
          }
          if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "assign-pending" || item.status_details.status.replace(' ', '-').trim().toLowerCase() == "on-hold") {
            return status.splice(1, 0, {
              order: 8,
              id: item.status_details.id,
              status: "On Hold",
              text: "On Hold",
              total: item.total_job,
            });
            // status[0].push(objectVal)
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "not-assigned") {
            return status.splice(2, 0, {
              order: 1,
              id: item.status_details.id,
              status: "Pending",
              text: "Pending",
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "assigned") {
            return status.splice(3, 0, {
              order: 3,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "acknowledged") {
            // return status.splice(4, 0, {
            //   order: 3,
            //   id: item.status_details.id,
            //   status: item.status_details.status,
            //   text: item.status_details.status,
            //   total: item.total_job,
            // });\
            AckTep = item
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "in-progress") {
            return status.splice(5, 0, {
              order: 5,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "completed") {
            return status.splice(6, 0, {
              order: 6,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "failed") {
            return status.splice(7, 0, {
              order: 7,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "cancelled") {
            return status.splice(8, 0, {
              order: 9,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "self-collect") {
            return status.splice(9, 0, {
              order: 10,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replaceAll(' ', '-').trim().toLowerCase() == "assigned-to-vendor") {
            // return status.splice(10, 0, {
            //   order: 2,
            //   id: item.status_details.id,
            //   status: item.status_details.status,
            //   text: item.status_details.status,
            //   total: item.total_job,
            // });
            AssignToVendorTemp = item
          }
        });

        status = status.sort(function(a, b) {
          return (a.order - b.order);
        });
        let tableStatus = status;
        status.unshift({
          id: 0,
          status: 'Total Orders',
          total: total,
        });
   
        // status.forEach(st=>{
        //   if(st.status == "In Progress") {
        //     st.total = st.total + AckTep.total_job
        //   }
        // })
        // 
        // if( Object.keys(AssignToVendorTemp).length !== 0 ) {
        //   status.forEach(st=>{
        //     if(st.status == "Assigned") {
        //       st.total = st.total + AssignToVendorTemp.total_job
        //     }
        //   })
        // }
        
        this.setState({
          status: status,
          status_total: complete_total + fail_total,
          tableStatus: tableStatus,
        });
        if(callback) {
          callback();
        }
      } else {
        if(callback) {
          callback();
        }
      }
    });
  }

  /* API */
  callStatusApi = (callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoadingStatus: true
    }, () => {
      let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());

      let param = {
        start_date: startDate,
        end_date: endDate,
        is_invoice_stats: true,
        is_standard:false,
      };

      ldsApi.read('orders/job/stats', param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            if(data && data.result){
              let total = data.total_delivery;
              let result = Object.keys(data.result).map((k) => data.result[k]);
              
              if(result && result.length > 0){
                this.setState({
                  isLoadingStatus: false,
                }, () => {
                  if(callback){
                    callback(result, total);
                  }
                });
              } else {
                this.setState({
                  isLoadingStatus: false,
                }, () => {
                  if(callback){
                    callback(null, 0);
                  }
                });
              }
            } else {
              this.setState({
                isLoadingStatus: false,
              }, () => {
                if(callback){
                  callback(null, 0);
                }
              });
            }
          }, (error, type) => {
            this.setState({
              isLoadingStatus: false,
            }, () => {
              if(callback){
                callback(null, 0);
              }
            });
          });
      });
    });
  }
  
  callDiscountList = (callback = null ) => {

    let accessToken = localStorage.getItem("access_token")
    this.setState({
      isLoading:true
    })
    let param = {
        // sort: "latest",
        // limit: 3,
      };

      ldsApi.read("order_discounts", param, accessToken)
      .then( (results) => {
          apiUtil.parseResult(results, (data) => {
          let result = data.result.length > 0 ? data.result : []
          this.setState({
            isLoading: false
          })
          if(callback) {
            callback(result)
          }
          }, (error, type) => {
            this.setState({
              isLoading: false
            })
            if(callback) {
              callback()
            }
          });
      });
  }

  callRecentActivityApi = () => {
    const { accessToken } = this.context;

    this.setState({
      isLoadingRecent: true
    }, () => {
      let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());

      let param = {
        page: this.state.page,
        take: this.state.limit,
        start_date: startDate,
        end_date: endDate,
      };

        ldsApi.read('dashboard/recent_activity/', param, accessToken)
        .then((result) => {
          // recent_activity
          apiUtil.parseResult(result, (data) => {
            const dataArr = (data.result && data.result.length > 0) ? data.result : []
            
            this.setState({
              recent_activity: dataArr,
              isLoadingRecent: false,
            });
          }, (error, type) => {
            this.setState({
              recent_activity: [],
              isLoadingRecent: false,
            });
          });

      });
    });
  }

  overviewDataApi = () => {
    const { accessToken } = this.context;
    
    this.setState({
      isLoadingClient: true
    }, () => {
      let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());

      let param = {
        customer_id: this.state.customer_id,
        take: this.state.limit,
        start_date: startDate,
        end_date: endDate,
        overview_type: 'customer'
      };

        ldsApi.read('/analytic/overview/', param, accessToken)
        .then((result) => {
          // recent_activity
          apiUtil.parseResult(result, (data) => {
            this.setState({
              overview_data: data.result,
              isLoadingClient: false,
            });
          }, (error, type) => {
            this.setState({
              overview_data: [],
              isLoadingClient: false,
            });
          });

      });
    });
  }

  callFactorApi = () => {
    const { accessToken } = this.context;
    
    this.setState({
      isLoadingFactor: true
    }, () => {
      let id = 0
      if(this.state.user.owner_info.customer_id != null && this.state.user.owner_info.customer_id.id != '') {
        id = this.state.user.owner_info.customer_id
      }

        wmsApi.details('/factors', id, accessToken)
        .then((result) => {
          // recent_activity
          apiUtil.parseResult(result, (data) => {
            const order = { S: 1, E: 2, C: 3, D: 4 };

            const sortedArray = data.result.sort((a, b) => {
              const firstCharA = a.title.charAt(0).toUpperCase();
              const firstCharB = b.title.charAt(0).toUpperCase();

              return order[firstCharA] - order[firstCharB];
            });

            this.setState({
              factors: sortedArray,
              isLoadingFactor: false,
            });
          }, (error, type) => {
            this.setState({
              factors: [],
              isLoadingFactor: false,
            });
          });

      });
    });
  }

  reasonApi = () => {
    const { accessToken } = this.context;
    let id = 0
    if(this.state.user.owner_info.customer_id != null && this.state.user.owner_info.customer_id.id != '') {
      id = this.state.user.owner_info.customer_id
    }
    this.setState({
      isLoadingReason: true
    }, () => {
      let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());

      let param = {
        customer_id: id,
        take: this.state.limit,
        start_date: startDate,
        end_date: endDate,
      };

        ldsApi.read('/analytic/reasons/', param, accessToken)
        .then((result) => {
          // recent_activity
          apiUtil.parseResult(result, (data) => {
            let dataArr = (data.result && data.result.length > 0) ? data.result : []
            let other_value = 0;
            dataArr.map((dd, index)=> {
              if (index > 6) {
                other_value = other_value + dd.value
              }
            })
            dataArr = dataArr.slice(0,5)
            dataArr.push({
              name: 'others',
              value: other_value,
            })
            this.setState({
              order_reasons: dataArr,
              reason_total: data.total,
              isLoadingReason: false,
            });
          }, (error, type) => {
            this.setState({
              order_reasons: [],
              reason_total: [],
              isLoadingReason: false,
            });
          });

      });
    });
  }

  callInitApis = () => {
    this.getCo2Ev(); 
    this.callRecentActivityApi();
    this.overviewDataApi();
    this.callFactorApi();
    this.reasonApi();
    this.getGrennerChoice();
    this.loadStatusApi(()=> {
      this.callDiscountList((result)=> {
        let discounts = result && result.sort((a,b) => a.eligible_order_count - b.eligible_order_count)
        let win_discount = discounts && discounts.filter(e => e.eligible_order_count < this.state.status_total).slice(-1)[0] 
        let current_discount = discounts && discounts.filter(e => e.eligible_order_count > this.state.status_total)[0] 

        if (typeof(current_discount) != 'undefined' && current_discount != null) {
          current_discount = current_discount 
        } else {
          if(discounts) {
            if(discounts.length == 1 || this.state.status_total == 0) {
              current_discount = discounts[0]
            } else if(discounts.length > 1) {
              current_discount = discounts[discounts.length - 1] 
            }
          }
        }

        this.setState({
          current_discount: current_discount,
          win_discount,
          discount_list: typeof(discounts) != 'undefined' ? discounts : [],
        })
      })
    });
    this.callReadApi();
  }
  
  getCo2Ev = () => {
    const { accessToken } = this.context;
    
    this.setState({
      co2EvLoading: true
    }, () => {
      let startDate = moment(this.state.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.endDate).format(apiUtil.getDefaultDateFormat());
  
      let param = {
        start_date: startDate,
        end_date: endDate,
      };
  
        ldsApi.read('/analytic/co2_ev_saving/', param, accessToken)
        .then((result) => {
          // recent_activity
          apiUtil.parseResult(result, (data) => {
            this.setState({
              co2_ev_saving: data.result.co2e_saving ? data.result.co2e_saving : 0,
              co2EvLoading: false,
            });
          }, (error, type) => {
            this.setState({
              co2_ev_saving: 0,
              co2EvLoading: false,
            });
          });
  
      });
    });     
  }

  /* EXPORT API */
  callExportXLSApi = () => {
    const { accessToken } = this.context;

    this.setState({
        downloadIsLoading: true
    }, () => {
      let startDate = moment(this.state.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.endDate).format(apiUtil.getDefaultDateFormat());

      let param = {
        start_date: startDate,
        end_date: endDate,
      };

      ldsApi.exportXLS('admin/api/orders/delivery/export', param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (response) => {
            apiUtil.saveToFile(response, `Orders ${moment(startDate).format('DD-MM-YYYY')} - ${moment(endDate).format('DD-MM-YYYY')}.xlsx`);
    
            this.setState({
              downloadIsLoading: false,
            });
          }, (error, type) => {
            if(result.status == 400) {
              apiUtil.toast('You can export maximum 10000 orders once.',  'warning', 'error');
            }
            this.setState({
              downloadIsLoading: false,
            });
          });
      });
    });
  }
  /* END EXPORT API */
  
  reasonPie = () => {
    return <Card className="p-3 analytic-chart-card d-flex flex-column h-350px w-100 align-items-center" style={{overflowY: 'auto'}}>
            <div className="fs-5 font-medium ps-2 pb-2">Reasons for Failure</div>
            {this.state.isLoadingReason? 
              <CircularProgress size={35} className="spinner-card" /> :
              <div className="h-400px w-100">
              <CustomPieChart 
                data={this.state.order_reasons} 
                dataKey={'value'} 
                key={'value'} 
                value1={'name'} 
                value2={'value'} 
                vertical_align={"center"} 
                align={"left"} 
                status_total={this.state.reason_total} 
                reason={true}
              /></div>
            }
            </Card>
  }
  
   /* TABLE */
   recentActivityTable = () => {
    return <OldTable 
      ref={this.refTable}
      className={'job-table w-100'}
      isLoading={this.state.isLoadingRecent}
      paging={false}
      data={this.state.recent_activity ? this.state.recent_activity.slice(0,20) : this.state.recent_activity}
      Toolbar={this.customToolbar}
      maxBodyHeight={360}
      Row={this.customRow}
      columns={[
        { 
          title: "#ID", 
          field: "id",
          width: "10%",
        },
        { 
          title: "Activity", 
          field: "description",
          width: "65%"
        },
        { 
          title: "Time", 
          field: "submitted_time",
          render: (row) => {
            let time = moment.utc(row.submitted_time);
            return moment.utc(row.submitted_time).local().format('LT');
          }
        },
      ]}
    />
  }

  leftTwoCard = () => {
    return <Col xs={12} md={12} lg={4} className="p-0 m-0 d-flex justify-content-center mb-4 mb-lg-0">
      <div className='w-100 p-0 m-0 '><Row className="p-0 m-0 overflow-hidden" style={{rowGap:'2.5em'}}>
    <Col xs={12} md={12} lg={12} className="p-0 m-0 d-flex justify-content-center">
      <Card className="p-3 mx-3 position-relative analytic-overview-card h-180px w-100 d-flex flex-column justify-content-start align-items-center">
      <div className="fs-5 ps-2 font-medium pb-2">CO2e Savings </div>
        <div className="fs-1 font-bold ps-2 pb-2 secondary-color d-flex h-100 justify-content-center align-items-center">{this.state.co2EvLoading? <CircularProgress size={35} className="spinner-card" /> : (this.state.co2_ev_saving && this.state.co2_ev_saving != 0? parseFloat(this.state.co2_ev_saving).toFixed(2) : '0.00') + 'kg'}</div>
        <div style={{position: "absolute", bottom: '7px', right:'7px'}}><img src={NaturalFood} style={{width:'40px', height:'40px'}}/></div>
      </Card>
    </Col>
    <Col xs={12} md={12} lg={12} className="p-0 m-0 d-flex justify-content-center">
      <Card className="p-3 mx-3 position-relative analytic-overview-card h-180px w-100 d-flex flex-column justify-content-start align-items-center">
        <div className="fs-5 ps-2 font-medium pb-2">Greener Choice </div>
        <div className="fs-1 font-bold ps-2 pb-2 secondary-color d-flex h-100 justify-content-center align-items-center">{this.state.grennerLoading? <CircularProgress size={35} className="spinner-card" /> : (this.state.greener_count > 0 ? this.state.greener_count : 0)}</div>
        <div style={{position: "absolute", bottom: '7px', right:'7px'}}><img src={Checkmark} style={{width:'35px', height:'35px'}}/></div>
      </Card>
    </Col>
  </Row></div>
  </Col>
  }

  render() {
    return <Container fluid className="overflow-hidden">
      <Row className="p-4 overflow-hidden">
        <Col xs={12} md={6}>
          <div className="fs-4 font-medium mb-lg-0 mb-2">Hey {this.state.user_name} !</div>
        </Col>
        <Col xs={12} md={6} className="d-flex justify-content-end align-items-center max-xs-width-control-100" style={{pointerEvents: this.state.isLoading || this.state.isLoadingOrder || this.state.isLoadingStatus ? 'none': 'auto' }}>
        <CustomDateRangePicker
              id={'select-dates-step-cus w-50'}
              range={this.state.rangeDate}
              onChange={(range) => {
                localStorage.setItem(this.pageName + '_rangeDate', JSON.stringify(range));
                this.setState({
                  rangeDate: range,
                  startDate: range.startDate,
                  endDate: range.endDate
                }, ()=> {
                  this.callInitApis();
                });
              }}
            />
            <Button className="upload-style"
                disabled={this.state.isLoadingStatus? true : false}
                onClick={() => {
                  this.setState({
                  downloadMenu:true
                });}}
        >{this.state.isLoadingStatus? <CircularProgress size={16} style={{zIndex: 20, color: "#FFFFFF"}}/> : <FontAwesomeIcon icon={faDownload} />}
        </Button>
          <Menu
            id="download-menu-job"
            anchorEl={this.state.downloadMenu}
            keepMounted
            getContentAnchorEl={null}
            open={Boolean(this.state.downloadMenu)}
            onClose={() => {
                this.setState({
                  downloadMenu: null
                });
            }}
          >
            <MenuItem onClick={() => {this.callExportXLSApi(); }} > Export CSV </MenuItem>
            <MenuItem 
            // onClick={() => { this.generatePDF()}} 
            disabled> Generate Label </MenuItem>
            <MenuItem  
            // onClick={() => { this.generatePOD() }} 
            disabled> Generate POD </MenuItem>
          </Menu>
        </Col>
      </Row>
      <Row className="pb-4 px-4 d-flex justify-content-between">
      <Col xs={12} md={8} lg={4} className="d-flex"><div className='font-medium'> Here’s an overview for {this.state.startDate? moment(this.state.startDate).format(apiUtil.getImportDateFormat()) : ''} {this.state.endDate ? '- ' + moment(this.state.endDate).format(apiUtil.getImportDateFormat()) : ''}</div></Col>
        <Col xs={12} md={8} lg={4} className="d-flex flex-column justify-content-end mb-4">
        {this.state.discount_list.length > 0 && this.state.discount_list.slice(0, 4).map((discount,index) =>(
          (typeof(this.state.current_discount) != 'undefined' && this.state.current_discount.discount_name == discount.discount_name) ?
            <div className="position-relative-discount">
                <div style={{position:"initial", textAlign:"center"}}>
                    <img src={index == 0 ? discount0: index == 1 ? discount1 : index == 2? discount2: index == 3 ? discount3: ''}  alt="5% discount" className="img-fluid position-absolute" />
                    <div className="position-absolute-text d-flex justify-content-center align-items-center" style={{fontWeight:"bold", fontSize:"9px",color:"white", lineHeight:1, zIndex: 100}}>{this.state.current_discount.discount_value}{this.state.current_discount.discount_type == 'rate'? '%':'$'} <br/>Off</div>
                </div>
                
                <div className={index == 0 ? "progress-num-color-1 text-end": index == 1 ? "progress-num-color-2 text-end" : index == 2? "progress-num-color-3 text-end": index == 3 ? "progress-num-color-4 text-end": ''}>{this.state.status_total}/{this.state.current_discount.eligible_order_count} deliveries ordered</div>
                <div className={`${index == 0 ? "progress-style-1 ": index == 1 ? "progress-style-2 " : index == 2? "progress-style-3 ": index == 3 ? "progress-style-4 ": ' '}" progress position-absolute-bar w-75 align-self-end"`}>
                  <div className="progress-bar" role="progressbar" style={{width: (this.state.status_total/Number(this.state.current_discount.eligible_order_count)) * 100 > 100 ? 100 +'%' : (this.state.status_total/Number(this.state.current_discount.eligible_order_count)) * 100 +'%'}} aria-valuenow={this.state.status_total} aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div> 
              : ''
        )) }
          
            
        </Col>
      </Row>
      <Row className="pb-4 px-4">
        <Col className="p-0 m-0 px-3 ">
        <Card className="analytic-chart-card h-200px" style={{overflow: 'auto'}}>
            <div style={{minWidth: '670px'}} className='d-flex flex-column align-items-center h-100 w-100'>
            <table style={{ borderRadius: "0.8em", height:'100%', width:'100%'}}>
              <tr className="cd-shadow w-100">
                <td className="py-3 text-center border fs-5 font-medium w-25">Deliveries Completed</td>
                <td className="py-3 text-center border fs-5 font-medium w-25">On-Time Deliveries</td>
                <td className="py-3 text-center border fs-5 font-medium w-25">Total Cost</td>
                <td className="py-3 text-center border fs-5 font-medium secondary-color w-25 position-relative">
                  My Green Score  <img src={NaturalFood} style={{width:'40px', height:'40px'}}/>
                </td>
              </tr>
              <tr style={{height:'100%'}}>
                <td  className="h-100 border text-center fs-3 font-medium position-relative-table primary-color">
                  {this.state.isLoadingClient? <CircularProgress size={35} className="spinner-card" /> : (this.state.overview_data.complete_delivery ? this.state.overview_data.complete_delivery : 0) + " / " + (this.state.overview_data.all_delivery ? this.state.overview_data.all_delivery : 0)}
                </td>
                <td  className="h-100 border text-center fs-3 font-medium primary-color">
                  {this.state.isLoadingClient? <CircularProgress size={35} className="spinner-card" /> : (this.state.overview_data.on_time_deliveries ? parseFloat(this.state.overview_data.on_time_deliveries).toFixed(2) : '0.00')+'%'}
                </td>
                <td  className="h-100 border text-center fs-3 font-medium primary-color">
                  {this.state.isLoadingClient? <CircularProgress size={35} className="spinner-card" /> : (this.state.overview_data.total_cost ? "$" + parseFloat(this.state.overview_data.total_cost).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00')} 
                </td>
                <td  className="h-100 border text-center fs-3 font-medium secondary-color">
                  {this.state.isLoadingClient? <CircularProgress size={35} className="spinner-card" /> : 
                  <div> 
                    <div className="fs-3 font-medium secondary-color"> {apiUtil.calculateGreenScore(this.state.overview_data, this.state.factors)}</div>
                    <div style={{}} className="text-dark"> <img src={BoxImportant} style={{width:'24px', height:'24px', cursor:'pointer'}} onClick={()=>this.props.history.push('/analytics/client-overview')}/> Score breakdown</div>
                  </div>}
                </td>
              </tr>
              </table>
            </div>
        </Card>
        </Col>
      </Row>
      <Row className="d-flex justify-content-between pb-4 px-4">
        <Col xs={12} md={6} lg={4} className="mb-4 p-0 m-0 px-3">
          <Card className="py-3 analytic-chart-card d-flex flex-column h-350px w-100 align-items-center" style={{overflowY: 'auto'}}>
            <div className="font-medium fs-5 py-2 overflowY-auto">Orders Placed</div>
            <table style={{width: '90%'}}>
             { this.state.status.map((status) => {
              return <tr className="border-bottom">
                <td className="py-2">{status.status}</td>
                <td className="py-2 w-100" style={{float: 'right'}}><div className={"customer-tag " + status.status.replaceAll(' ', '-').trim().toLowerCase()}>{status.total}</div></td>
              </tr>
              })}             
            </table>
          </Card>
        </Col>
        <Col xs={12} md={6} lg={4} className="mb-4 p-0 m-0 px-3">
            {this.reasonPie()}
        </Col>
        <Col xs={12} md={6} lg={4} className="mb-4 p-0 m-0 px-3">
        <Card className="py-3 analytic-chart-card h-350px w-100" style={{overflow: 'auto'}}>
              <div style={{minWidth: '370px'}} className='w-100 d-flex flex-column align-items-center'>
                <table className='w-100'>
                  <tr className='w-100'>
                    <td style={{width:'40%'}} className="font-medium fs-5 py-2 px-2">Invoices</td>
                    <td style={{width:'30%'}} className="font-medium fs-5 py-2 px-2 text-center">Billed Date</td>
                    <td style={{width:'30%'}} className="font-medium fs-5 py-2 px-2 text-center">Status</td>
                  </tr>
                  {this.state.data.length > 0 && this.state.data.map( (dd) => (
                    <tr className="border-bottom">
                    <td className="py-4 overflow-hidden px-2 text-center"><a href={dd.pdf_url} target="_blank" className="text-decoration-none d-flex"><FontAwesomeIcon icon={faFilePdf} /> {dd.invoice_number.substr(0, 15) + "..."}</a></td>
                    <td className="py-4 overflow-hidden px-2 text-center">{moment(dd.due_date, "YYYY-MM-DD").add(1, 'M').format('DD/MM/YYYY')}</td>
                    <td className="py-4 overflow-hidden px-2 text-center">{dd.is_paid ? <span className="font-medium" style={{color:"#0FBEA3"}}>Paid</span> : moment(moment(), "YYYY-MM-DD").unix() > moment(dd.due_date, "YYYY-MM-DD").add(1, 'M').unix()? <span className="font-medium" style={{color:"#FF0000"}}>Overdue</span> : <span className="font-medium" style={{color:"#FF881A"}}>Pending</span>}</td>
                  </tr>
                  ))}
                </table>
              </div>
          </Card>
        </Col>
        {this.leftTwoCard()}
        <Col xs={12} md={8} className="d-flex justify-content-center">
          <Card className={'p-3 recent-activities analytic-overview-card w-100 h-400px'}>
          <strong>Recent Activities</strong>
            {this.recentActivityTable()}
          </Card>
        </Col>
      </Row>
      <Row className="px-4 pb-4">
        <Col className="d-flex justify-content-center align-items-center p-0 m-0">
        <CustomUploadButton 
              className="upload-style-butom m-2"
              color={'primary'}
              accept={'.xls, .xlsx'}
              onChange={(files) => {
                if (files && files.length > 0){
                  this.setState({
                    openImportDialog: true,
                    openImportDialogItem: files[0],
                  });
                }
              }}
            >
              {/* <ImportIcon /> */}
             {this.state.isLoading? <CircularProgress size={35} /> : <><FontAwesomeIcon icon={faArrowUpFromBracket} />  &nbsp; &nbsp; Create Orders </>}
            </CustomUploadButton>
        </Col>
      </Row>
      {this.importDialog()}
      <div id="barcode" style={{display:'none'}}></div>
      <div id="qr" style={{display:'none'}}></div>
    </Container>
  }
}

export default CustomerDashboard;
